<div class="detail-parent-card" [style.gap.rem]="rows.length ? 2 : 1">
  <div class="d-flex justify-content-between align-items-center">
    <div class="d-flex flex-column gap-2">
      <span class="detail-card-title" i18n>Upcoming Lump Sum Payments</span>
      <div class="card-subtext" *ngIf="!!paymentDate" i18n>Payment on {{ paymentDate | date : 'MMM d, yyyy' }}*</div>
    </div>
    <app-text-button
      *ngIf="hasPreviousLumpSumPayments"
      [type]="ButtonTypeEnum.accent"
      (buttonClicked)="viewPastLumpSumPayments.emit()"
      i18n>
      View Past Lump Sum Payments
    </app-text-button>
  </div>
  <ng-container *ngIf="rows.length; else empty">
    <div class="d-flex flex-column gap-3">
      <ng-container *ngFor="let row of rows; trackBy: trackByIndex">
        <div class="payment-row">
          <div class="paragraph-lg" *ngIf="row.governingJurisdictionId">
            {{ row.governingJurisdictionId | governingJurisdictionName }}
          </div>
          <div class="paragraph-lg" *ngIf="!row.governingJurisdictionId" i18n>Non-Locked-In</div>
          <div class="amount-cell">
            <div class="row-amount">{{ row.amount | currency }}</div>
          </div>
        </div>
        <hr class="m-0" />
      </ng-container>
    </div>
    <div class="d-flex flex-column gap-3">
      <div class="d-flex justify-content-between align-items-center">
        <div class="title-sm" i18n>Lump Sum Payments Total:</div>
        <div class="title-sm">{{ total | currency }}</div>
      </div>
      <div class="payment-subtext" *ngIf="!!paymentDate" i18n>
        *The payment may not be issued on the exact date selected, but will be included in the next available payment
        batch
      </div>
    </div>
  </ng-container>
</div>

<ng-template #empty>
  <div class="card-subtext" i18n>There are no upcoming lump sum payments</div>
</ng-template>
